import { CentroCosto } from 'core/centrocosto/models/CentroCosto';
import { Tarjeta } from 'core/tarjeta/models/Tarjeta';

export const mapTipoUsuario = (tipoUsuario: TipoUsuario): string => {
  switch (tipoUsuario) {
    case 'CENTRO_COSTO':
      return 'Centro Costo';
    case 'PRISMA':
      return 'Operador';
    case 'TARJETA':
      return 'Tarjeta';
  }
};

export type TipoUsuario = 'PRISMA' | 'CENTRO_COSTO' | 'TARJETA';

export class Usuario {
  id: number;
  username: string;
  mail: string;
  detalle: string;
  tipoUsuario: TipoUsuario;
  cuentaRaiz: boolean;
  skipsRemaining: number;
  mailStatus: string;
  lastLogin: string;
  funcionalidades: string[] = [];
  recursoControlado: Partial<Tarjeta> | Partial<CentroCosto>;
}
